import { createSelector } from 'reselect';
import { AnyStateWithRefund, ReasonCategory } from '../types';

export const getSelectedReason = (state: AnyStateWithRefund) => state.refund.selectedReason;

export const getSelectedReasonDocument = createSelector(getSelectedReason, reason => reason?.docs?.[0]);

export const getIsSelectedVoluntaryReason = createSelector(
	getSelectedReason,
	reason => reason?.category === ReasonCategory.Voluntary
);

export const getIsSelectedInVoluntaryReason = createSelector(
	getSelectedReason,
	reason => reason?.category === ReasonCategory.Involuntary
);
